<template>
  <div class="info-404">
    <div v-if="!status">
      <img src="../../assets/img/404/404.png" />
      <p>
        当前投保人数过多,请稍后再试…
      </p>
    </div>
    <div v-else>
      <img :src="`${cdnresources}/prod/images/xiangaibao/overdue.png`" alt="" />
    </div>
  </div>
</template>

<script>
import { cdnresources } from '@/util/config'
export default {
  name: 'Page404',

  components: {},

  filters: {},

  mixins: [],

  props: {},

  data() {
    return {
      cdnresources
    }
  },

  computed: {
    status() {
      return !!this.$route.query.status
    }
  },

  watch: {},

  created() { },

  mounted() {
    document.title = '404'
  },

  destroyed() { },

  methods: {
    toJSON() { }
  }
}
</script>

<style scoped lang="scss">
.info-404 {
  height: 100%;
  padding-top: xvw(200);
  background-color: #fbfbfb;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  img {
    width: 90%;
  }

  p {
    margin-top: px2rem(34, 375);
    text-align: center;
    font-size: px2rem(16, 375);
    line-height: 1.5;
    color: #999;
  }
}
</style>
